import {APIStatusType} from '@web/core/constants'

export const AdStatus = {
    IDLE: 'IDLE',
    LOADED: 'LOADED',
    ERROR: 'ERROR',
} as const

export type AdStatusType = Constant<typeof AdStatus>

export type RecommendationProductState = {
    /** 상품 정보 */
    products: Array<{
        ecNvMid?: number
        orderDateTime?: string
        productOrderStatus?: string
        productPaymentAmount?: number
        productCategoryId?: string
    }>
    /** 광고 객체 */
    waterfallResponse: Maybe<object>
    /** API 응답 상태 */
    apiStatus: APIStatusType
    /** 광고 노출 상태 */
    adStatus: AdStatusType
}

export type RootState = {recommendationProduct: RecommendationProductState}
